import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSessionUser } from 'lib/store/session/selectors';

class Wootric extends Component {
  static supportedLanguages = {
    /**
     * Wootric doesn't support all languages, furthermore
     * Wootric use their own proprietary language code standard 🙃
     * This maps our apps determined BCP47 code to the Wootric standard.
     */
    bg: 'BG', // Bulgarian
    zh: 'CN_T', // Chinese Traditional
    nl: 'NL', // Dutch
    en: 'EN', // English
    et: 'ET', // Estonian
    fr: 'FR', // French
    de: 'DE', // German
    el: 'EL', // Greek
    it: 'IT', // Italian
    ja: 'JA', // Japanese
    ko: 'KO', // Korean
    pl: 'PL', // Polish
    pt: 'PT', // Portuguese
    ro: 'RO', // Romanian
    es: 'ES', // Spanish
    sv: 'SV', // Swedish
    uk: 'UK', // Ukrainian
  };

  static runWootricScript() {
    if (global.wootric && global.wootricSettings.email) {
      global.wootric('run');
    }
  }

  static propTypes = {
    userEmail: PropTypes.string,
    userJoinedAt: PropTypes.string,
    userRole: PropTypes.string,
    userRestaurants: PropTypes.arrayOf(PropTypes.string),
    userOrgs: PropTypes.arrayOf(PropTypes.string),
    language: PropTypes.string.isRequired,
  };

  static defaultProps = {
    userEmail: null,
    userJoinedAt: null,
    userRole: null,
    userRestaurants: [],
    userOrgs: [],
  };

  updateWootricSettings() {
    const {
      userEmail,
      userJoinedAt,
      userRole,
      userRestaurants,
      userOrgs,
      language,
    } = this.props;

    global.wootricSettings = {
      account_token: 'NPS-ff4e5e65',
      email: userEmail,
      created_at: (new Date(userJoinedAt) / 1000).toFixed(0),
      language: Wootric.supportedLanguages[language],
      properties: {
        platform: 'restaurant-hub-app',
        userRole,
        userRestaurants: userRestaurants.join(', '),
        userOrgs: userOrgs.join(', '),
      },
    };
  }

  componentDidUpdate() {
    this.updateWootricSettings();
    Wootric.runWootricScript();
  }

  componentDidMount() {
    // determine config for Wootric
    this.updateWootricSettings();
    // Load & Run Wootric script
    const wootricSdk = document.createElement('script');
    wootricSdk.type = 'text/javascript';

    wootricSdk.src = 'https://cdn.wootric.com/wootric-sdk.js';
    wootricSdk.onload = Wootric.runWootricScript;
    document.body.appendChild(wootricSdk);
  }

  render() {
    return <div />;
  }
}

export default connect((state) => {
  const user = getSessionUser(state);
  if (!user) return {};
  const { userJoinedAt, role, email, branchIds, orgIds } = user;
  return {
    userEmail: email,
    userJoinedAt,
    userRole: role,
    userRestaurants: branchIds,
    userOrgs: orgIds,
  };
}, null)(Wootric);
